import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { createCommission, changeCommissionStatus, changeCommissionStatusSuccess, updateCommission, toggleCommissionStatus, updateSubmittingState, updateSubmitErrorString, fetchCommission, openCommissionEditModal } from './actionCreators';
import { isApiError, requestNapi, requestPuppy } from '@wix/da-http-client';
import { call, all, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { normalize } from '../normalizr';
import { putEntities } from '../entities/actions';
import { deviationSchema } from '../normalizr/schemas/deviation';
import { CommissionStatusCodeMap, CommissionStatusType } from '../../types/commissions';
import { getCommissionById, getIsActive, getIsDeleted } from './selectors';
import { logBiEvent } from '../../biLogger/redux/saga';
import { ResourceType } from '../../types/resource';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { getCurrentUser } from '../../publicSession/selectors';
import noop from '../../utils/noop';
import { popModal, pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        return {
            success: true
        };
    }
}
function* doPapiRequest(endpoint, data) {
    return yield call(requestNapi, {
        method: 'post',
        url: endpoint,
        data
    }, fakeResponse);
}
function* createCommissionSaga(action) {
    const { title, pointsCost: points_cost, editorRawState, coverImageDeviationId } = action.payload;
    const params = {
        title,
        points_cost,
        cover_image_deviation_id: coverImageDeviationId,
        editorRaw: JSON.stringify(editorRawState)
    };
    const response = yield call(doPapiRequest, '/commission/create', params);
    if (response && response.deviation) {
        yield call(logBiEvent, PureBiData({
            evid: 11,
            group_exclusive: false,
            typeid: ResourceType.COMMISSION,
            itemid: response.deviation.deviationId
        }));
        const currentUser = yield select(getCurrentUser);
        window.location.href = `${Url.userShopPath(currentUser.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS)}?commission-publish-success=1`;
    } else if (response && response.errorCode === 302) {
        window.location.replace(response.errorDetails.redirectUrl);
    } else if (response && response.error === 'invalid_request' && response.errorDetails && response.errorDetails.Form) {
        yield put(updateSubmittingState({
            submittingState: 'error'
        }));
        yield put(updateSubmitErrorString({
            submitErrorString: `Creation of your new commission failed: ${response.errorDetails.Form}`
        }));
        yield call(alert, `Creation of your new commission failed: ${response.errorDetails.Form}`);
    }
}
export function* changeCommissionStatusSaga(action) {
    const { deviation, status } = action.payload;
    const response = yield call(doPapiRequest, '/commission/change_status', {
        commissionid: deviation.deviationId,
        status
    });
    if (response && response.success) {
        const updatedDeviation = _object_spread({}, deviation);
        updatedDeviation.commission.status = CommissionStatusCodeMap[response.data.status];
        const { entities } = normalize(updatedDeviation, deviationSchema);
        yield put(putEntities({
            entities
        }));
        yield put(changeCommissionStatusSuccess(updatedDeviation));
    }
}
export function* toggleCommissionStatusSaga(action) {
    const deviation = action.payload;
    const isDeleted = yield select(getIsDeleted, deviation.deviationId);
    if (isDeleted) {
        return;
    }
    const isActive = yield select(getIsActive, deviation.deviationId);
    const status = isActive ? CommissionStatusType.DISABLED : CommissionStatusType.ACTIVE;
    yield put(changeCommissionStatus({
        deviation,
        status
    }));
}
export function* updateCommissionSaga(action) {
    const { title, pointsCost: points_cost, coverImageDeviationId, editorRawState, commissionid, redirectOnSuccess = true, onSuccess = noop, onError = noop } = action.payload;
    const params = {
        commissionid,
        title,
        cover_image_deviation_id: coverImageDeviationId,
        points_cost,
        editorRaw: JSON.stringify(editorRawState)
    };
    const response = yield call(doPapiRequest, '/commission/update', params);
    if (response && response.deviation) {
        if (redirectOnSuccess) {
            window.location.assign(getDeviationUrl(response.deviation));
        } else {
            const { entities } = normalize(response.deviation, deviationSchema);
            yield put(putEntities({
                entities
            }));
            yield put(updateSubmittingState({
                submittingState: 'idle'
            }));
            yield call(onSuccess, response.deviation);
            return;
        }
    }
    yield put(updateSubmittingState({
        submittingState: 'error'
    }));
    yield put(updateSubmitErrorString({
        submitErrorString: 'No deviation in response'
    }));
    yield call(onError);
}
export function* fetchCommissionSaga({ payload: { deviationId, username, onSuccess } }) {
    const result = yield call(requestPuppy, {
        method: 'get',
        url: 'commission',
        params: {
            commissionid: deviationId,
            username,
            expand: 'deviation.fulltext'
        }
    }, fakeResponse);
    if (!isApiError(result) && (result === null || result === void 0 ? void 0 : result.deviation)) {
        const { entities } = normalize(result.deviation, deviationSchema);
        yield put(putEntities({
            entities
        }));
        if (onSuccess) {
            const deviation = yield select(getCommissionById, deviationId);
            yield call(onSuccess, deviation);
        }
    }
}
export function* openCommissionEditModalSaga({ payload: { params } }) {
    const openModal = function*(mergeParams) {
        yield put(pushModal(ModalType.COMMISSION, {
            params: _object_spread({}, params, mergeParams),
            wrapInModal: false
        }));
    };
    if (params.preload && params.deviation) {
        var _deviation_author;
        const deviation = params.deviation;
        yield put(pushModal(ModalType.LOADING_SCREEN, {}));
        var _deviation_author_username;
        yield put(fetchCommission({
            deviationId: deviation.deviationId,
            username: (_deviation_author_username = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username) !== null && _deviation_author_username !== void 0 ? _deviation_author_username : '',
            onSuccess: function*(responseDeviation) {
                yield put(popModal());
                yield call(openModal, {
                    deviation: responseDeviation
                });
            }
        }));
    } else {
        yield call(openModal);
    }
}
export default function* saga() {
    yield all([
        takeLatest(changeCommissionStatus, changeCommissionStatusSaga),
        takeLatest(toggleCommissionStatus, toggleCommissionStatusSaga),
        takeEvery(updateCommission, updateCommissionSaga),
        takeLatest(createCommission, createCommissionSaga),
        takeLatest(fetchCommission, fetchCommissionSaga),
        takeLatest(openCommissionEditModal, openCommissionEditModalSaga)
    ]);
}

//# sourceMappingURL=saga.js.map